import { BaseChannel } from "@app/channels/base_channel";

export class PaymentChannel extends BaseChannel {
  connected(){
    super.connected();
    console.log("Payment channel connected!");
  }

  disconnected() {
    super.disconnect();
    console.log("Payment channel disconnected!");
  }

  received(data){
    if (this.paymentController) {
      this.paymentController.handleMessage(data);
    }
  }

}
